export default {
    enableText: 'Enable',
    disableText: 'Disable',
    enableTexts: 'user',
    disableTexts: 'admin',
    yesText: 'Yes',
    noText: 'No',
    ExitedText: 'Exited',
    notUsedText: 'Unused',
    usedText: 'Used',
    notHaveText: 'None',
    haveText: 'Exist',
    notInitializedText: 'Uninitialized',
    initializedText: 'Initialized',
    manText: 'Male',
    womanText: 'Female',
    ACTIVEText: 'ACTIVE',
    UNACTIVEText: 'UNACTIVE',
    physicalGoodsText: 'Physical Product',
    virtualGoodsText: 'Virtual Product',
    generalMerchandiseText: 'Regular Product',
    EditingText: 'Editing',
    editSuccessfulText: 'Edit Successful',
    editFailedText: 'Edit Failed',
    CancellingText: 'Canceling',
    cancelSuccessfulText: 'Cancel Successful',
    cancelFailedText: 'Cancel Failed',
    packageItemText: 'Bundle Product',
    roughDraftText: 'Draft',
    tobeReviewedText: 'Pending',
    approvedText: 'Approved',
    rejectedText: 'Rejected',
    underReviewText: 'Reviewing',
    effectiveText: 'Effective',
    effectiveEditingText: 'Effective - Editing',
    effectiveRejectedText: 'Effective - Rejected',
    notSubmittedReviewText: 'Not submitted for review',
    completedText: 'Completed',
    InProcessing:"In Transit",
    Restocked:"Restocked",
    TemporaryStrong:"Temporary Storage",
    Discard:"Discard",
    Waitingforreturntowarehouse:"Awaiting Return To Warehouse",
    creditone:"Separate Credit Note, Send After Approval",
    credittwo:"Add To Invoice, Send Next Week",
    Completed:"Completed",
    allText:"All",
    WalletBalance:"Wallet Balance",
    WalletTransaction:"Wallet Transaction",
    completedOrderText: 'Completed Orders',
    cancelOrderText: 'Cancelled Orders',
    allOrderText: 'All Orders',
    costPriceText: 'Cost Price',
    salesPriceText: 'Sales Price',
    activityPriceText: 'Promotion Price',
    marketPriceText: 'Market Price',
    distributionPriceText: 'Distribution Price',
    tradePriceText: 'Wholesale Price',
    settlementPriceText: 'Settled Price',
    haveInHandText: 'In Progress',
    failedText: 'Failed',
    noConsumersText: 'No Consumers',
    waitingToBepulledText: 'Waiting to be pulled',
    AlibabaCloudText: 'Alibaba',
    HuaweiCloudText: 'Huawei',
    TencentCloudText: 'Tencent',
    QiniuCloudText: 'Qiniu',
    LocalText: 'Local',
    JDCloudText: 'JD Cloud',
    BaiduCloudText: 'Baidu Cloud',
    automaticLogonText: 'Automatic Registration',
    manualEntryText: 'Manual Entry',
    radioText: 'Radio',
    checkBoxText: 'Checkbox',
    textBoxText: 'Textbox',
    dropdownBoxText: 'Dropdown Box',
    loseEfficacyText: 'Invalid',
    efficacyText: 'Valid',
    positiveSequenceText: 'Ascending',
    invertedOrderText: 'Descending',
    onlineStoreText: 'Online Store',
    storeText: 'Physical Store',
    orderText: 'Sequence',
    constantText: 'Constant',
    dateText: 'Date',
    variableText: 'Variable',
    defaultVirtualWarehouseText: 'Default Virtual Warehouse',
    solidWarehouseText: 'Physical Warehouse',
    logicalWarehouseText: 'Logical Warehouse',
    orderItemShortagePriorityText: 'Order product out of stock priority',
    priorityGivenToStoreProductShortageText: 'Store product out of stock priority',
    notPublishedText: 'Unpublished',
    publishedText: 'Published',
    notSetText: 'Unset',
    setText: 'Set',
    auditSucceededText: 'Audit Successful',
    auditFailedText: 'Audit Failed',
    voidedText: 'Invalidated',
    deactivateText: 'Disabled',
    onHoldText: 'On Hold',
    openText: 'Enabled',
    suspendText: 'Paused',
    deadlineText: 'Expired',
    toBeWrittenOffText: 'To be Verified',
    auditRejectText: 'Audit Rejected',
    canceledText: 'Cancelled',
    wornText: 'Damaged',
    lostPartsText: 'Lost Parts',
    NormalStandardSellingPriceText: 'Regular Standard Selling Price',
    ExfactoryPriceText: 'Factory Price',
    InTransitText: 'In transit',
    CollectedText: 'Collected',
    ExceptionText: 'Exception',
    DeliveredText: 'Signed',
    SignBackText: 'Refused',
    OutForDeliveryText: 'Delivery',
    TransferText: 'Transfer',
    AwaitingClearanceText: 'Awaiting Clearance',
    ClearanceInProgressText: 'Clearing',
    ClearedText: 'Cleared',
    ClearanceExceptionText: 'Clearing Exception',
    freightTemplateMismatchText: 'Freight Template Mismatch',
    logisticsMismatchText: 'Logistics Mismatch',
    businessMismatchText: 'Business Mismatch',
    untreatedText: 'Unprocessed',
    processedText: 'Processed',
    ContainerText: 'Container',
    PalletsText: 'Pallets',
    CartonText: 'Carton',
    LooseText: 'Loose',
    PalletText: 'Pallet',
    billingByWeightText: 'Calculated by Weight',
    fixedPriceText: 'Fixed Price',
    standardUserText: 'standard',
    nonStandardUserText: 'non-standard',
    internalAllocationPriceText: 'Internal Allocation Price',
    NotWrittenBackText: 'Not Written Back',
    WriteBackSucceededText: 'Write Back Successful',
    WriteBackFailedText: 'Write Back Failed',
    UnreceivedGoodsText: 'Not Received',
    PartialReceiptText: 'Partially Received',
    ReceivedText: 'Received',
    ReceivedText1: 'Received',
    DeclinedText: 'Declined',
    DeclinedText1: 'Declined',
    OrderReplenishmentText: 'Order Replenishment',
    ShopReplenishmentText: 'Store Replenishment',
    wholeText: 'All',
    HEADCOUNT1: 'Pending Plan Submission',
    HEADCOUNT2: 'Plan Under Approval',
    HEADCOUNT3: 'Rejected',
    HEADCOUNT4: 'Pending Actual Submission',
    HEADCOUNT5: 'Completed',
    OVERTIME1: 'Overtime Under Approval',
    OVERTIME2: 'Rejected',
    OVERTIME3: 'Overtime Approved',
    cnPurchaseTypeText: 'Procurement in China',
    auPurchaseTypeText: 'Procurement in Australia',
    ukPurchaseTypeText: 'Procurement in Britain',
    SystemText: 'System',
    ManualText: 'Manual',
    FrozenText: 'Frozen',
    UnfrozenText: 'Unfrozen',
    ApprovalText: 'Approval Pending',
    AwaitingProcessingText: 'Awaiting Processing',
    ProgressText: 'In Progress',
    processingText: 'Processing',
    GeneralemailText: 'General Email',
    BillingEmailText: 'Billing Email',
    CustomerServiceEmailText: 'Customer Service Email',
    NotApprovedText: 'Approval Rejected',
    CancelledText: 'Cancelled',
    tombstoneText: 'Tombstone',
    PausedText: 'Paused',
    NotPausedText: 'Not Paused',
    ordinaryText: 'Normal',
    urgentText: 'Urgent',
    auditPassText: 'Approved',
    auditNotPassText: 'Rejected',
    DesignatedDepartmentText : 'Designated Department',
    BillingStatusPREVIEW: 'PREVIEW',
    ConfirmationPending: 'Confirmation Pending',
    CompletedText: 'Completed',
    BillingStatusPAID: 'PAID',
    BillingStatusPARTIAL: 'PARTIAL',
    BillingStatusUNPAID: 'UNPAID',
    BillingStatusOVERPAID: 'OVERPAID',
    BillingStatusDRAFT: 'Draft',
    BillingStatusRUNNING: 'Active',
    BillingStatusSTOP: 'Inactive',
    BillingStatusRange: 'Range',
    BillingStatusNormal: 'Normal',
    BillingStatusSection: 'Section',
    newQuotationTypeText: 'New Product',
    oldQuotationTypeText: 'Old Product',
    returnOrderStatusPendingText: 'Pending',
    returnOrderStatusBackText: 'Completed',
    returnOrderStatusAbandonedText: 'Abandon',
    returnProductStatusCompleteText: 'Excellent Condition',
    returnProductStatusDamagedText: 'Need Customer Advise',
    waitStockInText: 'Wait StockIn',
    allStockInText: 'All StockIn',
    successPushSapText: 'SAP Push Successful',
    failPushSapText: 'SAP Push Failed',
    PendingFirstTrialText: 'Awaiting First Review',
    PendingSecondReviewText: 'Awaiting Second Review',
    PassedInTheFirstInstanceText: 'First Review Approved',
    RefusalOfFirstInstanceText: 'First Review Rejected',
    PassedInTheSecondInstanceText: 'Second Review Approved',
    RejectionOfSecondInstanceText: 'Second Review Rejected',
    ToBeRefundedText: 'Awaiting Refund',
    RefusedText: 'Rejected',
    PurchaseWaitFirstAuditText: 'Wait First Audit',
    PurchaseFirstAuditRejectedText: 'First Audit Rejected',
    PurchaseWaitSecondAuditText: 'Wait Second Audit',
    PurchaseSecondAuditRejectedText: 'Second Audit Rejected',
    PurchaseWaitThirdAuditText: 'Wait Third Audit',
    PurchaseThirdAuditRejectedText: 'Third Audit Rejected',
    PurchaseCompletedText: 'Completed',
    PurchaseCancelledText: 'Cancelled',
    PurchaseWaitCreateText: 'Wait Produced',
    PurchaseProducingText: 'In Producing',
    PurchaseWaitPurchaseText: 'Wait Purchase',
    PurchaseDraftText: 'Draft',
    AbnormalDocumentTransferText: 'Transfer Exception',
    ToBeReturnedByTheBuyerText: 'Awaiting Buyer Return',
    ToBeAcceptedByTheWarehouseText: 'Awaiting Warehouse Inspection',
    ToBeShippedFromWarehouseText: 'Awaiting Warehouse Dispatch',
    ToBeReceivedByTheBuyerText: 'Awaiting Buyer Receipt',
    AuditTimeoutText: 'Audit Timeout',
    OutOfStockTimeoutText: 'Out-of-Stock Timeout',
    DeliveryTimeoutText: 'Delivery Timeout',
    OrderUpdateTimeoutText: 'Order Update Timeout',
    ToBeShippedText: 'Awaiting Dispatch',
    BuyerCancellationText: 'Buyer Cancelled',
    CloseExchangeText: 'Exchange Closed',
    RefusalToExchangeGoodsText: 'Exchange Rejected',
    OnlineStorePlatformRefundText: 'Online Store Refund',
    normalText: 'Normal',
    unusualText: 'Error',
    RefundOnlyText: 'Refund only',
    ReturnRefundText: 'Return and Refund',
    NotReturnedText: 'Not Synced',
    AfterSalesHasBeenReturnedText: 'After-Sales Synced',
    NotSynchronizedText: 'Not Synchronized',
    SynchronizedText: 'Synchronized',
    PendingText: 'Pending',
    PurchasedText: 'Purchased',
    TransferredText: 'Allocated',
    WarehouseMovedText: 'Transferred',
    GeneralOrderText: 'General Order',
    O2OOrdersText: 'O2O orders',
    QUATEStatus0: 'Not quoted',
    QUATEStatus1: 'Pending',
    QUATEStatus2: 'Confirmed',
    QUATEStatus3: 'Rejected',
    StoreSelfCollectionText: 'Store Pickup',
    LogisticsDistributionText: 'Logistics Delivery',
    OrdinaryDocumentTransferText: 'Normal Transfer',
    ManualOrderText: 'Manual order',
    CopyOrderText: 'Duplicate order',
    RepeatOrderText: 'Repeat Order',
    unfinishedText: 'Pending',
    ClosedText: 'Closed',
    UNClosedText: 'Not Closed',
    ReceiptToBeConfirmedText: 'Awaiting Confirmation of Receipt',
    AllToBeReservedText: 'All Awaiting Pre-Allocation',
    AllPreOccupiedSuccessfullyText: 'All Pre-Allocation Successful',
    FailedToPreOccupyAllText: 'All Pre-Allocation Failed',
    PartialPreoccupationText: 'Partial Pre-Allocation',
    CancelPreemptionText: 'Cancel Pre-Allocation',
    ToBeReservedText: 'Awaiting Pre-Allocation',
    PreoccupiedSuccessfullyText: 'Pre-Allocation Successful',
    PreemptionFailedText: 'Pre-Allocation Failed',
    UnoccupiedSuccessfullyText: 'Deallocation Successful',
    AllToBeWrittenBackText: 'All Awaiting Write-Back',
    WriteBackAllSucceededText: 'All Write-Back Successful',
    FailedToWriteBackAllText: 'All Write-Back Failed',
    PartialWritebackText: 'Partial Write-Back',
    ToBeWrittenBackText: 'Awaiting Write-Back',
    AllSourcesToBeSoughtText: 'All Awaiting Sourcing',
    AllSourcingSucceededText: 'All Sourcing Successful',
    AllSourcingFailedText: 'All Sourcing Failed',
    PartialSourcingText: 'Partial Sourcing',
    CancelSourcingText: 'Cancel Sourcing',
    SourceToBeBoughtText: 'Awaiting Sourcing',
    SourcingSucceededText: 'Sourcing Successful',
    SourcingFailedText: 'Sourcing Failed',
    initialText: 'Initial',
    AllToBeShippedText: 'All Awaiting Dispatch',
    AllShipmentsSucceededText: 'All Dispatch Successful',
    FailedToShipAllText: 'All Dispatch Failed',
    PartialShipmentText: 'Partial Dispatch',
    ShipmentSucceededText: 'Dispatch Successful',
    ShipmentFailedText: 'Dispatch Failed',
    GoodsToBeReceivedText: 'Awaiting Receipt',
    AllReceivedText: 'All Received',
    NotPendingText: 'Not Suspended',
    STAGE_LIST1: 'Request Submitted',
    STAGE_LIST2: 'Docs Approved',
    STAGE_LIST3: 'Finance Setup',
    STAGE_LIST4: 'Account Created',
    STAGE_LIST5: 'Checklist Upload',
    STAGE_LIST6: 'ERP Training',
    STAGE_LIST7: 'IT Solution',
    STAGE_LIST8: 'Final Check',
    STAGE_LIST9: 'Finish',
    OrderAllStatusNEWText: 'New',
    OrderAllStatusProcessingText: 'Processing',
    OrderAllStatusErrorText: 'Error',
    OrderAllStatusOutofStockText: 'Out-of-Stock',
    BusinessAbnormalOrderWAIRING: 'Waiting to be shipped',
    OrderAllStatusCollectText: 'Ready for Collection',
    OrderAllStatusCollectLabelText: 'Label Uploaded',
    AllSuspendedSuccessfullyText: 'All Suspended Successfully',
    FailedToSuspendAllText: 'All Suspended Failed',
    PartialPendingText: 'Partially Suspended',
    SystemSuspendedSuccessfullyText: 'System Suspension Successful',
    SystemSuspendFailedText: 'System Suspension Failed',
    SystemDecouplingSucceededText: 'System Un-suspension Successful',
    SystemDecouplingFailedText: 'System Un-suspension Failed',
    SuccessfullySuspendedManuallyText: 'Manual Suspension Successful',
    ManualSuspendFailedText: 'Manual Suspension Failed',
    ManualDecouplingSucceededText: 'Manual Un-suspension Successful',
    ManualDecouplingFailedText: 'Manual Un-suspension Failed',
    FailToPassTheFirstInstanceText: 'First Review Rejected',
    FailTheSecondInstanceText: 'Second Review Rejected',
    AlipayText: 'Alipay',
    QQPaymentText: 'QQ Payment',
    WeChatpaymentText: 'WeChat Pay',
    TenpayText: 'Tenpay',
    ContinuousPaymentText: 'Lianlian Pay',
    OnlineBankingText: 'Online Banking',
    cashOnDeliveryText: 'Cash on Delivery',
    BankRemittanceTransferText: 'Bank Transfer',
    otherText: 'Other',
    UnpaidText: 'Unpaid',
    PaidText: 'Paid',
    GeneralChargebackText: 'Normal Return',
    RefundOnlyIfNotShippedText: 'Unshipped Refund Only',
    OnSaleText: 'In Sales',
    AfterSalesText: 'After Sales',
    ReturnWithoutReasonWithin7DaysText: '7-day Unconditional Return',
    NotClosedText: 'Uncompleted',
    tradedText: 'Completed',
    NoAfterSalesServiceText: 'No After-sales',
    AfterSalesProcessingText: 'In After-sales Processing',
    RefundingText: 'In Refund',
    RefundSucceededText: 'Refund successful',
    InterfaceGrabText: 'API Capture',
    ManualDocumentCreationText: 'Manual Order Creation',
    EXCELImportText: 'Import',
    NoInvoicingRequiredText: 'No need for invoice',
    SellerPackageText: 'Seller pays for shipping',
    ToBeNotifiedWMSText: 'To be notified by WMS',
    ToBeDeliveredText: 'To be Shipped',
    FailedToNotifyWMSText: 'WMS Notification Failed',
    AllOutboundText: 'All Shipped',
    PartialDeliveryText: 'Partially Shipped',
    CancelIssueText: 'Cancelled Shipment',
    ParsingSucceededText: 'Parsing Successful',
    NoParsingRequiredText: 'No Need for Parsing',
    ReconciledText: 'Reconciled',
    UnreconciledText: 'Unreconciled',
    NoReconciliationRequiredText: 'No need for reconciliation',
    paymentForGoodsText: 'Goods Payment',
    commissionText: 'Commission',
    OrthocurrentWaterText: 'Positive Transaction',
    NegativeCurrentText: 'Negative Transaction',
    AmountAbnormalityText: 'Abnormal Amount',
    SignedForText: 'Signed',
    ReturnedText: 'Returned',
    visaRejectedText: 'Refused to Sign',
    SettledText: 'Settled',
    UnsettledText: 'Unsettled',
    roundDownText: 'Round down',
    roundUpText: 'Round up',
    transferVirtualWarehouseText: 'Transfer Virtual Warehouse',
    proportionalVirtualWarehouseText: 'Proportional Virtual Warehouse',
    quantityVirtualWarehouseText: 'Quantity Virtual Warehouse',
    salesRevenueText: 'Sales Revenue',
    refundExpensesText: 'Refund Expenditure',
    DetailsOfAllExpensesText: 'All Expense Details',
    MatchingFeeDetailsText: 'Matching Expense Details',
    UnMatchingFeeDetailsText: 'Unmatched expense details',
    mateText: 'Matching',
    MatchingAmountText: 'Matching (amount difference)',
    mismatchingText: 'Not Matching',
    ConfirmedText: 'Confirmed',
    UnconfirmedText: 'Unconfirmed',
    Batchconfirmation: 'Bulk Confirm',
    AmountDifferenceText: 'Amount Difference',
    GetFixedFieldsText: 'Fetch Fixed Fields',
    calculateAccordingToTheFormulaText: 'Calculate by Formula',
    SalesOrderText: 'Sales Order',
    RefundOrderText: 'Refund Order',
    ReturnAndRefundOrderText: 'Return and Refund Order',
    ExchangeOrderText: 'Exchange Order',
    handMovementText: 'Manual',
    voluntarilyText: 'Automatic',
    MeetsAllOfTheFollowingConditionsText: 'Meets all of the following conditions',
    MeetsAnyOfTheFollowingConditionsText: 'Meets any of the following conditions',
    SalesChannelText: 'Sales Channel',
    OrderSourceText: 'Order Source',
    OrderTypeText: 'Order Type',
    OrderFlagText: 'Order Tag',
    ThirdPartyPlatformDownloadText: 'Third-party Platform Download',
    ManuallyCreatedText: 'Manual Creation',
    FileImportText: 'File Import',
    stockoutText: 'Out of Stock',
    OrderCompletedText: 'Order Completion',
    ShipmentCompletedText: 'Shipment Completion',
    AfterSalesChannelText: 'After-Sales Channel',
    AfterSalesOrderSourceText: 'After-Sales Order Source',
    AfterSalesOrderTypeText: 'After-Sales Order Type',
    AfterSalesCompletedText: 'After-sales Completion',
    AuditCompletedText: 'Audit Completion',
    NotStartedText: 'Not Started',
    InProgressText: 'In Progress',
    EndedText: 'Ended',
    TerminatedText: 'Terminated',
    ThirdPartyOrderTimeText: '3rd Party Order Time',
    PaymentTimeText: 'Payment Time',
    AllStoresText: 'All Stores',
    SpecifiedStoresText: 'Specified Stores',
    AllProductsInStoreText: 'All Products in Store',
    SpecifiedProductsText: 'Specified Products',
    FullGiftText: 'Buy More Get Gift',
    ReissueOrderText: 'Reshipment order',
    ReturnOrderText: 'Return order',
    RefundNoteText: 'Refund order',
    OrderOutOfStockText: 'Out of stock order',
    OrderExceptionText: 'Abnormal order',
    MarketingProductsText: 'Promotion Product',
    PurchaseOrdersText: 'Purchase Orders',
    NormalCategoryText: 'General Category',
    LeafCategoryText: 'Leaf Category',
    NewText: 'New',
    SystemDefaultText: 'System Default',
    ParentCategoryText: 'Parent Category',
    AdditionalAttributeText: 'Additional Attribute',
    ProductAttributeText: 'Product Attribute',
    CategoryAttributeText: 'Category Attribute',
    NotDeployedText: 'Not Deployed',
    DeployedText: 'Deployed',
    MenuText: 'Menu',
    ButtonText: 'Button',
    PageText: 'Page',
    TabText: 'Label',
    ReviewedText: 'Reviewed',
    ByThirdPpartyOrderTimeText: 'By Customer Date Ordered',
    ByThirdPpartyOrderTimeText2: 'By Order time by platform',
    ByInternalCreationTimeText: 'By CSG Date Created',
    ByChannelText: 'By Channel',
    ByMonthText: 'By Month',
    ByRegionText: 'By Region',
    UnauthorizedText: 'Unauthorized',
    AuthorizedSuccessfullyText: 'Authorization Successful',
    AuthorizationInvalidText: 'Authorization Expired',
    AuthorizationSuspendedText: 'Authorization Disabled',
    MatchedSuccessfullyText: 'Matched Successfully',
    MatchedFailedText: 'Matched Failed',
    AutomaticMatchingText: 'Automatically Matched',
    ManualMatchingText: 'Manually Matched',
    OnShelfText: 'On Sale',
    OffShelfText: 'Off Sale',
    NormalProductText: 'Regular Product',
    PromotionalProductText: 'Promotional Product',
    clientText: 'Client',
    NotPrintedText: 'Not Printed',
    PrintedText: 'Printed',
    SalesStoreText: 'Store',
    selectText: 'Select',
    RoleText: 'Role',
    AccountNumberText: 'Account',
    PersonalCenterText: 'Account Center',
    ExitSystemText: 'Log Out',
    SelectProductText: 'Select Products',
    SelectVirtualProductText: 'Select Virtual Products',
    SelectPhysicalItemText: 'Select Physical Products',
    SelectPackageProductText: 'Select Package Products',
    SelectCommonProductText: 'Select Regular Products',
    SelectSKUText: 'Select SKU',
    SelectPOText: 'Select PO',
    SelectOrderText: 'Select Order',
    SelectStoreText: 'Select Store',
    SelectOnlineStoreText: 'Select Online Store',
    SelectWarehouseText: 'Select Warehouse',
    SelectLogicalWarehouseText: 'Select Logical Warehouse',
    SelectPhysicalWarehouseText: 'Select Physical Warehouse',
    SelectSalesOrderText: 'Select Related Sales Order',
    SelectRefundProductText: 'Select Refund Products',
    SelectThirdPartyOrderText: 'Select Related Third-party Order',
    SelectSupplierProductText: 'Select supplier product',
    SelectPurchaseOrderText: 'Select Purchase Order',
    OrderLogText: 'Order Log',
    SupplierLogText: 'Supplier Log',
    staffSelectText: 'Select Staff',
    welcomeText: 'WELCOME TO CSG ERP SYSTEM',
    lockTip1: 'Dear Customer,',
    lockTip2: 'We hope this message finds you well. We would like to inform you that your account has been temporarily restricted due to one of the following reasons:',
    lockTip3: '1.An unpaid overdue bill, or',
    lockTip4: '2.Your account exceeds the assigned credit limit.',
    lockTip5: 'To restore full access to your account, please make the necessary payment at your earliest convenience. If the restriction is due to a credit limit issue,kindly contact our customer service team for assistance. ',
    lockTip6: 'Thank you for your prompt attention to this matter.',
    formatErrorText: 'Format Error',
    PleaseAddressText: 'Please Enter Address',
    IncorrectAddressFormatText: 'Invalid Address Format',
    PleaseEmailAddressText: 'Please Enter Email',
    MailboxFormatText: 'Invalid Email Format',
    PleaseAccountText: 'Please Enter Account',
    PleaseCorrectAccountText: 'Please Enter Valid Account',
    PleasePhoneNumberText: 'Please Enter Mobile Number',
    MobileFormatErrorText: 'Invalid Mobile Number Format',
    PleaseClassificationText: 'Please Enter Charge Item',
    PleaseCENText: 'Chinese, English letters, and numbers',
    Please20NumbersText: 'Please Enter Numbers and Letters No More than 20 Characters',
    ContentText: 'Content',
    LastweekText: 'Last week',
    LastmonthText: 'Last month',
    LastThreeMonthsText: 'Last 3 Months',
    oneText: 'One ',
    twoText: 'Two ',
    threeText: 'Three ',

    OrganizationText: 'Associated organizational structure',
    OperatingUserText: 'Operating user',
    OperationContentText: 'Operation content',
    OperatingTimeText: 'Operating time',
    MsgErrorListText: 'Failed to get data list',
    ConfirmImportText: 'Confirm import',
    UploadFileSizeText: 'The maximum upload file size cannot exceed 128M',
    DownTemplate: 'Please add template address',
    TemplatedMsgText: 'Missing parameters',
    UploadMsgText: 'The file has been submitted, you can go to the Import History page to view the import results',
    UploadMainText1: 'Drag the file here, or ',
    UploadMainText2: 'Click to upload',
    UploadMainHint1: 'can only upload',
    UploadMainHint2: 'File，And not more than',
    UploadSuccessText: 'number of successes',
    UploadFailText: 'Number of failures',
    UploadTotalText: 'The total amount',
    UploadFormatText1: 'only support',
    UploadFormatText2: 'format, the current file format is',
    UploadMsgError: 'size cannot exceed',
    ReplicationSucceededText: 'Replication succeeded',
    copyText: 'Copy',
    createText: 'Create',
    uploadedFormatText: 'The format of the uploaded image is incorrect, please upload it again',
    uploadedSizeText: 'The size of the uploaded image cannot exceed',
    loginSucceededText: 'Login succeeded',
    FormatText1: 'format',
    FormatText2: ' the format is ',

    appliesMerchantText: "Buyer applies for a refund, awaiting merchant's processing",
    processedMerchantText: "Return and refund, awaiting merchant's processing",
    refundMerchantText: 'Merchant approves the refund, refund in progress',
    agreesMerchantText: 'Platform approves the refund, refund in progress',
    rejectedMerchantText: "Refund rejected, awaiting buyer's processing",
    returnMerchantText: "Return and refund approved, awaiting user's shipment",
    PlatformMerchantText: 'Platform processing',
    refusesMerchantText: 'Platform rejects the refund, refund closed',
    revocationMerchantText: 'Buyer cancels',
    notprocessedMerchantText: 'Buyer fails to process within the deadline, refund failed',
    overdueMerchantText: 'Buyer exceeds the deadline, expired',
    processingMerchantText: "Replacement and reshipment, awaiting merchant's processing",
    pendingMerchantText: "Replacement and reshipment, awaiting user's processing",
    successfulMerchantText: 'Replacement and reshipment successful',
    failedMerchantText: 'Replacement and reshipment failed',
    confirmedMerchantText: "Replacement and reshipment awaiting user's confirmation of completion",
    WaitMerchantText: "Awaiting merchant's agreement for repair",
    shipmentMerchantText: "Awaiting user's confirmation for shipment",
    closedMerchantText: 'Repair closed',
    RepairMerchantText: 'Repair successful',
    confirmationMerchantText: "Awaiting user's confirmation of receipt",
    rejectMerchantText: "Approved refund for refusal, awaiting user's refusal",
    SupplementaryMerchantText: "Reshipment awaiting merchant's shipment",
    rootText: 'root',
    importHistoryText: 'Import History',
    reasonText: 'Reason',
    AllocationRatioText: 'Allocation ratio',
    straightLineText: 'straight line',
    polylineText: 'polyline',
    avoidanceLineText: 'avoidance line',
    railLineText: 'rail line',
    relationshipLineText: 'relationship line',
    itemText: 'Item',
    packageText: 'Package Box',
    matchingAnomalyText: 'Product Matching Error',
    sizeAnomalyText: 'Product size anomaly',
    timeAnomalyText: 'Order time anomaly',
    addressAnomalyText: 'Delivery address anomaly',
    priceAnomalyText: 'Unit price anomaly',
    phoneAnomalyText: "Recipient's phone number anomaly",
    SKUDimensionText: "SKU Dimension Exception",
    AddressExceptionText: "Address Exception (over 40 characters)",
    informationAnomalyText: 'Recipient information anomaly',
    supplierAnomalyText: 'Platform/supplier anomaly',
    taxAnomalyText: 'Tax number anomaly',
    AccountAnomalyText: 'Account number anomaly',
    CurrencyAnomalyText: 'Currency anomaly',
    ItemAnomalyText: 'Item anomaly',
    StoreAnomalyText: 'Store matching anomaly',
    BuyerNotesText: 'Buyer notes pending customer service review',
    BuyerSTOCKText: 'OUT OF STOCK',
    BuyerSTOCKPOText: 'Exceeds PO Box limits',
    BuyerHSCodeText: 'HS Code, Country of Origin, Cost Price required',
    BuyerPickupText: 'Pickup orders do not allow a delivery address',
    printText: 'Print',

    loginTip: 'Please login again',
    Pendingurgentorders: 'Pending urgent orders',
    PendingHJcancelorders: 'Pending HJ cancel orders',
    pohasnotclosed: 'Pending PO closure in ERP',
    dataDuplication: 'Data duplication',

    PackageDimensionsRequired: 'Package Dimensions Required',
    PackageDimensionsProvided: 'Package Dimensions Provided',
    ShippingQuoteRequired: 'Shipping Quote Required',
    FreightProvided: 'Shipping Quote Provided',
    FreightConfirmed: 'Shipping Quote Confirmed',
    ApprovedText2: 'Approved',
    ApprovedPending: 'Approval Pending',
    ApprovedRejected: 'Approval Rejected',
    ApprovalDescription: 'Approval Description',
    RejectedTicket: 'Rejected Ticket',
    ApprovalPending: 'Approval Pending',
    OverdueTicket: 'Overdue Ticket',
    ApprovalsOnboarding: 'Pending Onboarding Approvals',
    InStorage: 'In Storage',
    ShippingError: 'Shipping method not configured, Please Check',
    closingTime: 'Closing Time',

    // 包裹类型
    Q_PackageText: 'Parcel',
    Q_DocumentText: 'Document',
    Q_BagText: 'PAK',
    // 计算方式
    Q_LookupText: 'Rate Table Lookup',
    Q_IncrementalText: 'Incremental Rating',
};
